/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import {
  Grid,
  Box,
  Button,
  Autocomplete,
  TextField,
  Card,
  CardContent,
  Typography,
} from '@mui/material';
import { ContainerPainel, Title } from '../../styles/GlobalStyles';
import Loading from '../../components/Loading';
import axios from '../../services/axios';
import BarChartViagens from './BarChartViagens';
import BarChartDespesas from './BarChartDespesas';
import BarReceitaKm from './BarReceitaKm';
import BarDespesaKm from './BarDespesaKm';
import BarKmConsumo from './BarKmConsumo';
import PieBalanco1 from './PieBalanco1';
import PieBalanco2 from './PieBalanco2';
import LineBalanco3 from './LineBalanco3';
import BarPesoPorKmconsumo from './BarPesoPorKmconsumo';
import BarKmconsumorPeso from './BarKmconsumorPeso';
import BarViagemDetalhe from './BarViagemDetalhe';
import BarDespesasDetalhe from './BarDespesasDetalhe';
import BarConsumo from './BarConsumo';
import BarRodado from './BarRodado';

dayjs.locale('pt-br');

export default function Dashboard() {
  const [motoristas, setMotoristas] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [veiculos, setVeiculos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [viagens, setViagens] = useState([]);
  const [viagensDetalhe, setViagensDetalhe] = useState([]);
  const [despesas, setDespesas] = useState([]);
  const [despesasDetalhe, setDespesasDetalhe] = useState([]);
  const [id_motorista, setIdMotorista] = useState(null);
  const [id_veiculo, setIdVeiculo] = useState(null);
  const [id_empresa, setIdEmpresa] = useState(null);
  const [id_cliente, setIdCliente] = useState(null);
  const [mes, setMes] = useState(null);
  const [ano, setAno] = useState(null);
  const [currentYear, setcurrentYear] = useState(new Date().getFullYear());
  const [isLoading, setIsLoading] = useState(false);

  // Busca a lista de motoristas
  useEffect(() => {
    setIsLoading(true);
    async function fetchMotoristas() {
      const response = await axios.get('/motoristas');
      setMotoristas(response.data);
    }
    async function fetchVeiculos() {
      const response = await axios.get('/veiculos');
      setVeiculos(response.data);
    }
    async function fetchEmpresas() {
      const response = await axios.get('/empresas');
      setEmpresas(response.data);
    }
    async function fetchClientes() {
      const response = await axios.get('/clientes');
      setClientes(response.data);
    }
    fetchMotoristas();
    fetchVeiculos();
    fetchEmpresas();
    fetchClientes();
    setIsLoading(false);
  }, []);

  // Busca a lista de viagens de acordo com o motorista selecionado
  async function fetchAll() {
    setcurrentYear(new Date().getFullYear());
    let params = {};
    if (id_motorista) {
      params.id_motorista = id_motorista;
    }
    if (id_veiculo) {
      params.id_veiculo = id_veiculo;
    }
    if (id_empresa) {
      params.id_empresa = id_empresa;
    }
    if (id_cliente) {
      params.id_cliente = id_cliente;
    }
    if (mes) {
      params.mes = mes ? mes.month() + 1 : null;
    }
    if (ano) {
      params.ano = ano ? ano.year() : null;
    }

    let response = await axios.get('/viagens/dashboard', { params });
    setViagens(response.data);

    response = await axios.get('/viagens/dashboardDetalhe', { params });
    setViagensDetalhe(response.data);

    params = {};
    if (id_veiculo) {
      params.id_veiculo = id_veiculo;
    }
    if (id_empresa) {
      params.id_empresa = id_empresa;
    }
    if (id_cliente) {
      params.id_cliente = id_cliente;
    }
    if (mes) {
      params.mes = mes ? mes.month() + 1 : null;
    }
    if (ano) {
      params.ano = ano ? ano.year() : null;
    }
    response = await axios.get('/controledespesas/dashboard', { params });
    setDespesas(response.data);

    response = await axios.get('/controledespesas/dashboardDetalhe', {
      params,
    });
    setDespesasDetalhe(response.data);
  }

  useEffect(() => {
    setIsLoading(true);
    fetchAll();
    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function limparFiltros() {
    setMes(null);
    setAno(null);
    setIdMotorista(null);
    setIdVeiculo(null);
    setIdEmpresa(null);
    setIdCliente(null);
    setViagens([]);
    setDespesas([]);
    setViagensDetalhe([]);
    setDespesasDetalhe([]);
    setcurrentYear('');
  }

  return (
    <ContainerPainel>
      <Loading isLoading={isLoading} />
      <Title>GRÁFICOS</Title>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                required
                label="Mês"
                size="small"
                value={mes} // Assumindo que mes é um objeto de data
                onChange={(date) => setMes(date)} // Armazena o objeto de data completo
                views={['month']}
                format="MM"
                inputFormat="MM"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                required
                label="Ano"
                size="small"
                value={ano} // Assumindo que mes é um objeto de data
                onChange={(date) => setAno(date)} // Armazena o objeto de data completo
                views={['year']}
                format="YYYY"
                inputFormat="YYYY"
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_motorista}
              value={
                motoristas.find((option) => option.id === id_motorista) || null
              }
              options={motoristas}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdMotorista(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  label="Motorista"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_veiculo}
              value={
                veiculos.find((option) => option.id === id_veiculo) || null
              }
              options={veiculos}
              getOptionLabel={(option) => option.placa}
              onChange={(event, newValue) => {
                setIdVeiculo(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  label="Veículo"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_empresa}
              value={
                empresas.find((option) => option.id === id_empresa) || null
              }
              options={empresas}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdEmpresa(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  label="Empresa"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              id={id_cliente}
              value={
                clientes.find((option) => option.id === id_cliente) || null
              }
              options={clientes}
              getOptionLabel={(option) => option.nome}
              onChange={(event, newValue) => {
                setIdCliente(newValue ? newValue.id : '');
              }}
              renderInput={(params) => (
                <TextField
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...params}
                  label="Cliente"
                  size="small"
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => fetchAll()}
              style={{ marginRight: '10px' }}
            >
              Filtrar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => limparFiltros()}
            >
              Limpar Filtros
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Card style={{ height: '400px' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Balanço Geral(
                {ano?.format ? ano.format('YYYY') : ano || currentYear})
              </Typography>
              <PieBalanco1 dados1={viagens} dados2={despesas} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card style={{ height: '400px' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Viagens Mês x Valor(
                {ano?.format ? ano.format('YYYY') : ano || currentYear})
              </Typography>
              <BarChartViagens dados={viagens} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card style={{ height: '400px' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Receitas x Total de Despesas(
                {ano?.format ? ano.format('YYYY') : ano || currentYear})
              </Typography>
              <PieBalanco2 dados1={viagens} dados2={despesas} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card style={{ height: '400px' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Receitas x Total de Despesas - Mês(
                {ano?.format ? ano.format('YYYY') : ano || currentYear})
              </Typography>
              <LineBalanco3 dados1={viagens} dados2={despesas} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card style={{ height: '400px' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Lançamento de Despesas(
                {ano?.format ? ano.format('YYYY') : ano || currentYear})
              </Typography>
              <BarChartDespesas dados={despesas} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card style={{ height: '400px' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Receita por Km Rodado(
                {ano?.format ? ano.format('YYYY') : ano || currentYear})
              </Typography>
              <BarReceitaKm dados={viagens} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card style={{ height: '400px' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Despesa por Km Rodado(
                {ano?.format ? ano.format('YYYY') : ano || currentYear})
              </Typography>
              <BarDespesaKm dados={viagens} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card style={{ height: '400px' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Consumo Km/L(
                {ano?.format ? ano.format('YYYY') : ano || currentYear})
              </Typography>
              <BarKmConsumo dados={viagens} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card style={{ height: '400px' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Fator KmL/T(
                {ano?.format ? ano.format('YYYY') : ano || currentYear})
              </Typography>
              <BarKmconsumorPeso dados={viagens} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card style={{ height: '400px' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Fator T/KmL(
                {ano?.format ? ano.format('YYYY') : ano || currentYear})
              </Typography>
              <BarPesoPorKmconsumo dados={viagens} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card style={{ height: '400px' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Despesas de Viagens(
                {ano?.format ? ano.format('YYYY') : ano || currentYear})
              </Typography>
              <BarViagemDetalhe dados={viagensDetalhe} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card style={{ height: '400px' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Despesas Fixas(
                {ano?.format ? ano.format('YYYY') : ano || currentYear})
              </Typography>
              <BarDespesasDetalhe dados={despesasDetalhe} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card style={{ height: '400px' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Consumo Diesel L(
                {ano?.format ? ano.format('YYYY') : ano || currentYear})
              </Typography>
              <BarConsumo dados={viagens} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Card style={{ height: '400px' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Km Rodado (
                {ano?.format ? ano.format('YYYY') : ano || currentYear})
              </Typography>
              <BarRodado dados={viagens} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </ContainerPainel>
  );
}
